import Model from './Model'

export default class ProductStock extends Model {
  resource () {
    return 'stocks'
  }
}
